<button
  class="back-button"
  (click)="onClick()"
  [dir]="direction"
  (keyup.enter)="onClick()"
  (keyup.space)="onClick()"
  tabindex="0"
  role="button"
  [attr.aria-label]="ariaText"
>
  @if (withIcon && !oppositeIconPlacement) {
    <div
      class="icon rotate180Rtl"
      [style.background-color]="color"
      [ngStyle]="{ mask: 'url(' + icon + ') no-repeat center', '-webkit-mask': 'url(' + icon + ') no-repeat center' }"
    ></div>
    <ng-container *ngTemplateOutlet="textTemplate"></ng-container>
  } @else if (withIcon && oppositeIconPlacement) {
    <ng-container *ngTemplateOutlet="textTemplate"></ng-container>
    <div
      class="icon rotate180Ltr"
      [style.background-color]="color"
      [ngStyle]="{ mask: 'url(' + icon + ') no-repeat center', '-webkit-mask': 'url(' + icon + ') no-repeat center' }"
    ></div>
  } @else {
    <ng-container *ngTemplateOutlet="textTemplate"></ng-container>
  }
</button>

<ng-template #textTemplate>
  <div
    [style.color]="color"
    [style.font-weight]="fontWeight"
    [style.font-size]="fontSize"
    [style.padding-inline-end]="withIcon && oppositeIconPlacement ? textPadding : 0"
    [style.padding-inline-start]="withIcon && !oppositeIconPlacement ? textPadding : 0"
  >
    {{ text }}
  </div>
</ng-template>
